import { useState, useEffect, useRef } from "react";
const BASE = "https://imalishawelfare.com/api";
const tok = () => sessionStorage.getItem("token") || localStorage.getItem("adminToken");
const fmt = n => "KSh " + Number(n||0).toLocaleString("en-KE");
const fmtDate = d => {
  if (!d) return "�";
  try { return new Date((d.includes("+")||d.includes("Z"))?d:d+"+03:00").toLocaleString("en-KE",{timeZone:"Africa/Nairobi",day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit",second:"2-digit"}); }
  catch(e){ return d; }
};
const statusColor = s => ({LOGIN_SUCCESS:"#10b981",LOGIN_FAILED:"#ef4444",STK_SENT:"#7c3aed",FEE_PAID:"#0066cc",PAYMENT_FAILED:"#ef4444",DISBURSED:"#10b981",APPLIED:"#f59e0b",APPROVED:"#0052a3",SUCCESS:"#10b981",FAILED:"#ef4444",PENDING:"#f59e0b"}[s]||"#94a3b8");

export default function ActivityMonitor() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [search, setSearch] = useState("");
  const intervalRef = useRef(null);

  const load = async (silent) => {
    if (!silent) setLoading(true);
    try {
      const r = await fetch(BASE+"/admin/activity", { headers:{ Authorization:"Bearer "+tok() } });
      if (r.ok) { setRows(await r.json()); setLastUpdate(new Date()); }
    } catch(e) {}
    setLoading(false);
  };

  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (autoRefresh) intervalRef.current = setInterval(()=>load(true), 10000);
    else clearInterval(intervalRef.current);
    return () => clearInterval(intervalRef.current);
  }, [autoRefresh]);

  const filtered = rows.filter(r => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (r.userName||"").toLowerCase().includes(q) ||
      (r.userEmail||"").toLowerCase().includes(q) ||
      (r.phone||"").includes(q) ||
      (r.eventType||"").toLowerCase().includes(q) ||
      (r.detail||"").toLowerCase().includes(q) ||
      String(r.applicationId||"").includes(q);
  });

  return (
    <div style={{fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>

      {/* Header bar */}
      <div style={{background:"#0f172a",borderRadius:10,padding:"14px 20px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:8,height:8,background:autoRefresh?"#10b981":"#94a3b8",borderRadius:"50%",boxShadow:autoRefresh?"0 0 8px #10b981":"none"}}/>
          <span style={{color:"white",fontWeight:700,fontSize:14}}>Live Activity Monitor</span>
          <span style={{color:"rgba(255,255,255,0.4)",fontSize:12}}>� Last updated: {lastUpdate.toLocaleTimeString("en-KE",{timeZone:"Africa/Nairobi"})} � {rows.length} events</span>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <div style={{position:"relative"}}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={{position:"absolute",left:8,top:"50%",transform:"translateY(-50%)"}}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..."
              style={{padding:"7px 10px 7px 26px",border:"1px solid rgba(255,255,255,0.15)",borderRadius:7,fontSize:12,width:180,background:"rgba(255,255,255,0.08)",color:"white"}}/>
          </div>
          <button onClick={()=>setAutoRefresh(a=>!a)}
            style={{padding:"7px 14px",background:autoRefresh?"#10b981":"#475569",color:"white",border:"none",borderRadius:7,fontSize:12,fontWeight:600,cursor:"pointer"}}>
            {autoRefresh?"Auto ON":"Auto OFF"}
          </button>
          <button onClick={()=>load()}
            style={{padding:"7px 14px",background:"rgba(255,255,255,0.1)",color:"white",border:"1px solid rgba(255,255,255,0.2)",borderRadius:7,fontSize:12,fontWeight:600,cursor:"pointer"}}>
            Refresh
          </button>
        </div>
      </div>

      {/* Table */}
      <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 6px rgba(0,0,0,0.06)",overflow:"hidden"}}>
        <div style={{padding:"12px 16px",borderBottom:"1px solid #f1f5f9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <h3 style={{fontSize:14,fontWeight:700,color:"#1e293b",margin:0}}>Activity Log</h3>
          <span style={{fontSize:12,color:"#94a3b8"}}>{filtered.length} records</span>
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead>
              <tr style={{background:"#f8fafc"}}>
                {["id","event_type","user_name","user_email","phone","detail","amount","application_id","status","created_at"].map(h=>(
                  <th key={h} style={{padding:"10px 12px",textAlign:"left",fontWeight:700,color:"#64748b",fontSize:10,textTransform:"uppercase",letterSpacing:.5,whiteSpace:"nowrap",borderBottom:"1px solid #e2e8f0"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={10} style={{padding:48,textAlign:"center",color:"#94a3b8"}}>Loading...</td></tr>
              ) : filtered.length===0 ? (
                <tr><td colSpan={10} style={{padding:48,textAlign:"center",color:"#94a3b8"}}>No activity yet</td></tr>
              ) : filtered.map((r,i)=>(
                <tr key={r.id||i} style={{borderTop:"1px solid #f1f5f9",background:["LOGIN_FAILED","PAYMENT_FAILED"].includes(r.eventType)?"#fff5f5":["FEE_PAID","DISBURSED","LOGIN_SUCCESS"].includes(r.eventType)?"#f8fffe":i%2?"#fafafa":"white"}}>
                  <td style={{padding:"8px 12px",color:"#94a3b8",fontSize:11,fontFamily:"monospace"}}>{r.id}</td>
                  <td style={{padding:"8px 12px"}}>
                    <span style={{background:statusColor(r.eventType)+"15",color:statusColor(r.eventType),borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700,fontFamily:"monospace",whiteSpace:"nowrap"}}>
                      {r.eventType||"NULL"}
                    </span>
                  </td>
                  <td style={{padding:"8px 12px",fontWeight:600,color:"#1e293b",whiteSpace:"nowrap"}}>{r.userName||"NULL"}</td>
                  <td style={{padding:"8px 12px",color:"#64748b",fontSize:11}}>{r.userEmail||"NULL"}</td>
                  <td style={{padding:"8px 12px",fontFamily:"monospace",color:"#334155",whiteSpace:"nowrap"}}>{r.phone||"NULL"}</td>
                  <td style={{padding:"8px 12px",color:"#64748b",fontSize:11,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.detail||"NULL"}</td>
                  <td style={{padding:"8px 12px",fontWeight:r.amount?700:400,color:r.amount?"#059669":"#94a3b8",whiteSpace:"nowrap"}}>{r.amount?fmt(r.amount):"NULL"}</td>
                  <td style={{padding:"8px 12px",color:"#0066cc",fontWeight:r.applicationId?700:400,fontFamily:"monospace"}}>{r.applicationId?"APP-"+r.applicationId:"NULL"}</td>
                  <td style={{padding:"8px 12px"}}>
                    <span style={{background:statusColor(r.status)+"15",color:statusColor(r.status),borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700,fontFamily:"monospace"}}>
                      {r.status||"NULL"}
                    </span>
                  </td>
                  <td style={{padding:"8px 12px",color:"#64748b",fontSize:11,whiteSpace:"nowrap"}}>{fmtDate(r.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
